{
  "chart": {
    "header": "Chart",
    "otherLinkedDocuments": "Other linked documents",
    "hideCategories": "Hide categories",
    "groupByGraphs": "Group by graphs",
    "includeDrafts": "Include non published documents",
    "noDraftsToInclude": "No non published documents available to include",
    "sharedFrom": "Shared from {{unit}}"
  }
}
